import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { Container, Row, Col } from "react-bootstrap";
import DynamicPages from "../../components/branch-io/dynamic-pages.json";
import CommonStructured from "../../components/common-components/CommonStructured";
import HelmetWrapper from "../../HelmetWrapper";
import { selectUser } from "../../components/auth/auth.selector";
import CmnFilters from "../../components/lead-management/common/CmnFilters";
import DLLists from "../../components/branch-io/DLLists";

const DynamicLinkin = () => {
  const userInfoData = useSelector(selectUser);

  const iniAllFilter = {
    searchString: "",
  };
  const [allFilters, setAllFilters] = useState(iniAllFilter);
  // const iniFilters = {};
  // const [filters, setFilters] = useState(iniFilters);
  const [searchFilterApplied, setSearchFilterApplied] = useState(false);
  const [filteredData, setFilteredData] = useState(DynamicPages);

  const onResetFilters = () => {
    setAllFilters(iniAllFilter);
    setFilteredData(DynamicPages);
    setSearchFilterApplied(false);
  };

  const onClickSearch = () => {
    if (allFilters.searchString.trim() !== "") {
      setSearchFilterApplied(true);
      const filteredResults = DynamicPages?.filter((page) =>
        page?.screen_label
          ?.toLowerCase()
          ?.includes(allFilters.searchString?.toLowerCase())
      );
      setFilteredData(filteredResults);
    }
  };

  useEffect(() => {
    if (allFilters.searchString.trim() === "") {
      setSearchFilterApplied(false);
      setFilteredData(DynamicPages);
    }
  }, [allFilters.searchString]);

  return (
    <HelmetWrapper title="WTF: Metabase Links">
      <Container className="bg-cloud-k px-50px gobal-container" fluid>
        <Row>
          <Col>
            <CommonStructured pageHeading={"Dynamic Linking"} />
          </Col>
        </Row>
        <Row>
          <Col>
            <CmnFilters
              from={"dynamic-linking"}
              userInfoData={userInfoData}
              onClickReset={onResetFilters}
              filters={allFilters}
              setFilters={setAllFilters}
              onClickSearch={onClickSearch}
              searchFilterApplied={searchFilterApplied}
              searchPlaceHolder={"Search by screen name"}
            />
          </Col>
        </Row>
        <Row>
          <Col>
            <DLLists userInfoData={userInfoData} DynamicPages={filteredData} />
          </Col>
        </Row>
      </Container>
    </HelmetWrapper>
  );
};

export default DynamicLinkin;
